import React, { useEffect, useState, useRef, createElement } from 'react';
const testimonials = [{
  quote: "Mateo's vast design knowledge was so helpful during my studies. Far beyond just a designer, Mateo brings a holistic approach to product development. He is so passionate about his work - and it shows!",
  name: 'ALEX HOLDER',
  title: "DESIGN @ DICK'S SPORTING GOODS",
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Alex.jpg'
}, {
  quote: 'Mateo was the TA for our UX Design Bootcamp. He always made himself available and went out of his way to help us achieve our goals. He clearly has a deep understanding of the field.',
  name: 'ERIC LAMONTAGNE',
  title: 'WEB STRATEGY TECHNICAL LEAD',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Eric.jpg'
}, {
  quote: 'Mateo is a great person to work with and I would be happy to be a reference for him.',
  name: 'TRACEY JACKSON',
  title: 'A11Y SPECIALIST, US BANK',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Tracey.jpg'
}];
export function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  // Load UnicornStudio script
  useEffect(() => {
    if (!window.UnicornStudio) {
      window.UnicornStudio = {
        isInitialized: false
      };
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v1.4.29/dist/unicornStudio.umd.js';
      script.onload = () => {
        if (!window.UnicornStudio.isInitialized) {
          window.UnicornStudio.init();
          window.UnicornStudio.isInitialized = true;
        }
      };
      (document.head || document.body).appendChild(script);
    }
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target === sectionRef.current) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const testimonialWidth = 380;
  const testimonialMargin = 12;
  const totalWidth = testimonials.length * (testimonialWidth + testimonialMargin * 2);
  return <section className="bg-white overflow-hidden" data-id="element-2050">
      {/* Upper testimonials section with ticker */}
      <div ref={sectionRef} className="py-16 sm:py-24 md:py-32 px-4 sm:px-6 md:px-8" data-id="element-2051">
        <div className="container mx-auto" data-id="element-2052">
          <h2 className="text-2xl sm:text-4xl md:text-5xl text-center mb-10 sm:mb-16 md:mb-20 uppercase leading-tight text-gray-800" style={{
          fontFamily: "'Gefika', sans-serif",
          fontWeight: 400,
          letterSpacing: '0.02em',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
        }} data-id="element-2053">
            CLIENT & CO-WORKER COMMENTS
          </h2>
          <div className="relative overflow-hidden h-[360px] sm:h-[420px] mb-12 sm:mb-20" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.8s ease-out 0.3s, transform 0.8s ease-out 0.3s'
        }} data-id="element-2054">
            {/* Testimonials ticker */}
            <div className="absolute w-full h-full" data-id="element-2055">
              <div className="ticker-testimonials flex" data-id="element-2056">
                {/* First set of testimonials */}
                {testimonials.map((testimonial, index) => <div key={`first-${index}`} className="testimonial-item flex-shrink-0 w-[280px] sm:w-[320px] md:w-[380px] mx-3 sm:mx-5 md:mx-6 transition-all duration-300" data-id="element-2057">
                    <div className="bg-white p-5 sm:p-7 md:p-8 shadow-sm border border-gray-100 rounded-sm flex flex-col justify-between h-full" data-id="element-2058">
                      <p className="text-[#444444] leading-relaxed mb-6 sm:mb-10 md:mb-12 text-base sm:text-lg font-switzer" data-id="element-2059">
                        "{testimonial.quote}"
                      </p>
                      <div className="mt-auto" data-id="element-2060">
                        <div className="flex items-center mb-3" data-id="element-2061">
                          <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full overflow-hidden mr-3" data-id="element-2062">
                            <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover transition-all duration-300 grayscale hover:grayscale-0" data-id="element-2063" />
                          </div>
                          <div data-id="element-2064">
                            <p className="font-medium text-gray-900 text-sm sm:text-base tracking-wider font-switzer" data-id="element-2065">
                              {testimonial.name}
                            </p>
                            <p className="text-gray-600 text-xs sm:text-sm tracking-wider font-switzer" data-id="element-2066">
                              {testimonial.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>)}
                {/* Duplicate sets for seamless loop */}
                {[...Array(3)].map((_, setIndex) => testimonials.map((testimonial, index) => <div key={`set-${setIndex}-${index}`} className="testimonial-item flex-shrink-0 w-[280px] sm:w-[320px] md:w-[380px] mx-3 sm:mx-5 md:mx-6 transition-all duration-300" data-id="element-2067">
                      <div className="bg-white p-5 sm:p-7 md:p-8 shadow-sm border border-gray-100 rounded-sm flex flex-col justify-between h-full" data-id="element-2068">
                        <p className="text-[#444444] leading-relaxed mb-6 sm:mb-10 md:mb-12 text-base sm:text-lg font-switzer" data-id="element-2069">
                          "{testimonial.quote}"
                        </p>
                        <div className="mt-auto" data-id="element-2070">
                          <div className="flex items-center mb-3" data-id="element-2071">
                            <div className="w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full overflow-hidden mr-3" data-id="element-2072">
                              <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover transition-all duration-300 grayscale hover:grayscale-0" data-id="element-2073" />
                            </div>
                            <div data-id="element-2074">
                              <p className="font-medium text-gray-900 text-sm sm:text-base tracking-wider font-switzer" data-id="element-2075">
                                {testimonial.name}
                              </p>
                              <p className="text-gray-600 text-xs sm:text-sm tracking-wider font-switzer" data-id="element-2076">
                                {testimonial.title}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>))}
              </div>
            </div>
            {/* Gradient overlays */}
            <div className="absolute left-0 top-0 h-full w-[100px] sm:w-[150px] md:w-[250px] bg-gradient-to-r from-white via-white to-transparent z-10" data-id="element-2077"></div>
            <div className="absolute right-0 top-0 h-full w-[100px] sm:w-[150px] md:w-[250px] bg-gradient-to-l from-white via-white to-transparent z-10" data-id="element-2078"></div>
          </div>
        </div>
      </div>

      <style jsx data-id="element-2079">{`
        .ticker-testimonials {
          animation: testimonialTicker 80s linear infinite;
          will-change: transform;
        }
        @keyframes testimonialTicker {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${totalWidth * 2}px);
          }
        }
        .testimonial-item {
          position: relative;
        }
        .testimonial-item::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: white;
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }
      `}</style>
    </section>;
}